import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: '맛집 추천 서비스',
        text: '오늘 뭐 먹지? 맛집 추천받아보세요!',
        url: window.location.href,
      });
    } else {
      // 폴백: 클립보드에 복사
      navigator.clipboard.writeText(window.location.href);
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };

  return (
    <div className="footer">
      {/* 광고 영역 */}
      <div className="ad-section">
        <p className="ad-text">📢 광고 배너</p>
        <p className="ad-subtext">맛집 정보 더 많이 보기</p>
      </div>

      {/* 추가 기능 버튼들 */}
      <div className="additional-buttons">
        <button className="additional-btn" onClick={handleRefresh}>
          <span>🔄</span>
          <span>초기화</span>
        </button>
        <button className="additional-btn" onClick={handleShare}>
          <span>📤</span>
          <span>공유</span>
        </button>
      </div>
    </div>
  );
};

export default Footer;